import { isDesktopShell } from "shared/utils/isDesktopShell"

// True when the app is already running installed — as the packaged Electron
// or Tauri desktop build, or as a PWA added to the home screen/launched
// standalone — as opposed to a regular browser tab. Used to hide "download
// the app" prompts once the visitor is already inside the app they'd be
// downloading.
export function isStandaloneApp() {
  const isStandaloneDisplay = window.matchMedia?.("(display-mode: standalone)").matches
  const isIosStandalone = window.navigator.standalone === true

  return Boolean(isDesktopShell() || isStandaloneDisplay || isIosStandalone)
}
